import $ from 'jquery';

export default class WCCheckoutChangeBillingForm {
    constructor() {
        if (window.global.is_checkout) {
            this.checkoutEvents();
        }
    }

    checkoutEvents() {
        const self = this;

        this.setFields();
        this.getStartingClientType();

        $(document.body).on('updated_checkout', () => {
            self.setListenersToEvents();
        });
    }

    setFields() {
        this.checkoutBillingData = document.querySelector(
            '.jsWcCheckoutBillingData',
        );

        this.clientTypeRadios = [
            ...document.querySelectorAll('.jsWcCheckoutClientType'),
        ];

        if (this.checkoutBillingData) {
            this.firstNameWrap = this.checkoutBillingData.querySelector(
                '#billing_first_name_field',
            );
            this.firstNameInput = this.checkoutBillingData.querySelector(
                '#billing_first_name',
            );

            this.lastNameWrap = this.checkoutBillingData.querySelector(
                '#billing_last_name_field',
            );
            this.lastNameInput =
                this.checkoutBillingData.querySelector('#billing_last_name');

            this.addressWrap = this.checkoutBillingData.querySelector(
                '#billing_address_1_field',
            );
            this.addressInput =
                this.checkoutBillingData.querySelector('#billing_address_1');

            this.companyWrap = this.checkoutBillingData.querySelector(
                '#billing_company_field',
            );
            this.nipWrap =
                this.checkoutBillingData.querySelector('#billing_nip_field');
        }
    }

    getStartingClientType() {
        const checkedRadio = this.clientTypeRadios.filter(
            (radio) => radio.checked,
        );

        if (checkedRadio.length) {
            this.setFieldsRequiredClasses(checkedRadio[0]?.value);
        }
    }

    setListenersToEvents() {
        if (this.clientTypeRadios.length) {
            this.clientTypeRadios.forEach((radio) =>
                radio.addEventListener(
                    'change',
                    this.changeBillingFrom.bind(this),
                ),
            );
        }
    }

    changeBillingFrom(e) {
        const selectedRadio = e.currentTarget;

        if (!selectedRadio) return;

        const radioValue = selectedRadio.value;

        if (!radioValue) return;

        this.clientTypeRadios.forEach((radio) => {
            if (radioValue === radio.value) {
                radio.setAttribute('checked', 'checked');
            } else {
                radio.removeAttribute('checked');
            }
        });

        $(document.body).trigger('update_checkout');

        this.setFieldsRequiredClasses(radioValue);
    }

    setFieldsRequiredClasses(customerType) {
        if (customerType === 'company') {
            this.companyWrap.classList.add('validate-required');
            this.companyWrap.style.display = 'block';

            this.nipWrap.classList.add('validate-required');
            this.nipWrap.style.display = 'block';

            this.firstNameWrap.classList.remove('validate-required');
            this.firstNameInput.setAttribute(
                'placeholder',
                'Imię osoby kontaktowej (opcjonalnie)',
            );

            this.lastNameWrap.classList.remove('validate-required');
            this.lastNameInput.setAttribute(
                'placeholder',
                'Nazwisko osoby kontaktowej (opcjonalnie)',
            );

            this.addressWrap.classList.add('validate-required');
            this.addressInput.setAttribute('placeholder', 'Ulica i numer *');
        } else if (customerType === 'client') {
            this.companyWrap.classList.remove('validate-required');
            this.companyWrap.style.display = 'none';

            this.nipWrap.classList.remove('validate-required');
            this.nipWrap.style.display = 'none';

            this.firstNameWrap.classList.add('validate-required');
            this.firstNameInput.setAttribute('placeholder', 'Imię*');

            this.lastNameWrap.classList.add('validate-required');
            this.lastNameInput.setAttribute('placeholder', 'Nazwisko*');

            this.addressWrap.classList.remove('validate-required');
            this.addressInput.setAttribute(
                'placeholder',
                'Ulica i numer (opcjonalnie)',
            );
        }
    }
}
